export const steps = [
  'const_proposal_sumary',
  'const_proposal_analysis',
  'const_scope_registration',
  'const_attachments'
];
